import { useState, useEffect } from 'react';
import useIsMobileView from "../../hooks/useIsMobileView";
import { LoadingIcon } from '@prosolve/common-components-ui'
import useDataSessions from  '../../dataHooks/useDataSessions'
import useDataEvents from  '../../dataHooks/useDataEvents'
import ScheduleCalendarView from './ScheduleCalendarView';
import ScheduleListView from './ScheduleListView';
import Tabs from '../sharedComponents/Tabs';
import useSnackbar from '../../hooks/useSnackbar';
import StartTimeOffsetButton from './StartTimeOffsetButton';

export default () => {
  const isMobileView = useIsMobileView();

  const urlParams = new URLSearchParams(window.location.search);
  const eventId = urlParams.get('id');
  const key = urlParams.get('key');

  const {
    isLoading: isSessionsLoading,
    sessions,
    fetchSessions
  } = useDataSessions();

  const {
    isLoading: isValidateLogisticsLoading,
    validateShareLogistics,
    fetchValidateShareLogistics,
  } = useDataEvents();

  const isShowEdit = Boolean(validateShareLogistics)

  const { fetchEvent } = useDataEvents();
  const { updateSessions } = useDataSessions()
  const { newMessage } = useSnackbar()

  const [isEventLoading, setIsEventLoading] = useState(true)
  const [isUpdateSessionLoading, setIsUpdateSessionLoading] = useState()
  const [eventData, setEventData] = useState({})

  const onUpdate = async (sessionData) => {
    if (!sessionData) {
      await fetchSessions({ eventId })
    } else {
      await fetchUpdateSessions(sessionData)
    }
  }

  const fetchEventData = async () => {
    setIsEventLoading(false)
    try {
      const data = await fetchEvent(eventId)
      setEventData(data)
    } catch(e) {
      console.log(e)
      setEventData({})
    }
    setIsEventLoading(false)
  }
  
  const fetchUpdateSessions = async (...sessionData) => {
    setIsUpdateSessionLoading(sessionData)
    try {
      await updateSessions(sessionData)
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Save failed', severity: 'failure' })
    }
    setIsUpdateSessionLoading()
  }

  const fetchValidateShareLogisticsData = async () => {
    const data = await fetchValidateShareLogistics({key})
    if (!data?.success) {
      newMessage({
        message: 'Your link is expired, request a new link to edit the schedule. You may still view the schedule using the expired link.',
        severity: 'failure'
      })
    }
  }

  useEffect(() => {
    fetchEventData()
    fetchSessions({ eventId })
    if (key) {
      fetchValidateShareLogisticsData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const {
    timeZone = ''
  } = eventData;

  const tabs = ['Board', 'List', 'Calendar'];

  const [selectedTab, setSelectedTab] = useState('Board')

    return (
      <div 
        style={{ 
          display: 'flex',
          flexDirection: 'column',
          padding: isMobileView ? '5px' : '20px', 
          columnGap: '20px'
        }}
      >
        <div style={{
          color: '#565656',
          // padding: '20px',
          paddingTop: '0px',
          borderBottom: '1px solid #C2C9D1'
        }}>
          <div style={{ display: 'flex' }}>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              flex: 1
            }}>
              {'Schedule'}
            </div>
            {!isShowEdit && 
              <Tabs 
                tabs={tabs} 
                selectedTab={selectedTab} 
                setSelectedTab={setSelectedTab} 
                suppressBorderBottom={true}
                suppressSelectionBorderBottom={true}
              />
            }
          </div>
          {Boolean(timeZone) &&
            <div style={{ fontSize: '13px', marginTop: '10px', marginBottom: '10px' }}>
              {`All times are in the ${timeZone} time zone`}
            </div>
          }
          {eventData?.id && sessions?.length > 0 &&
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '13px', marginTop: '10px', marginBottom: '10px' }}>
              <StartTimeOffsetButton eventData={eventData} sessions={sessions} onUpdate={onUpdate} />
            </div>
          }
        </div>
        {
          (isEventLoading || isSessionsLoading || isValidateLogisticsLoading) ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '40px'
          }}>
            <LoadingIcon />
          </div>
          :
          (
            (selectedTab === 'Board' || selectedTab === 'List') ?
            <ScheduleListView 
              sessions={sessions} 
              eventData={eventData} 
              isHorizView={selectedTab === 'Board'} 
              isShowEdit={isShowEdit}
              onUpdate={onUpdate}
              isUpdateLoading={isUpdateSessionLoading}
            />
            :
            <ScheduleCalendarView sessions={sessions} eventId={eventId} />
          )
            
        }
      </div>
    )
}